// Globally register all layouts for convenience, because they
// will be used very frequently. Layouts are registered using their file name.
import Vue from 'vue'
import { eachInContext } from '@evolve/helpers/RequireHelper'

eachInContext(require.context('./layouts'), Vue.component.bind(Vue))
